import React from "react";
import "../post.css";
import DayNine from "../images/day_nine.jpg";

export default class Post extends React.Component {
  render() {
    return (
      <div className="card">
        <h2 className="header">Day Nine</h2>
        <img className="image" alt="itinerary" src={DayNine} />
        <div className="infobar">
          <div className="info">28 Nov 2018</div>
        </div>
        <h3>Morning</h3>
        <p>
          Universal Studios Japan. Buy a whole day e-pass from Klook. Queue
          early at the entrance and don't forget a map. Best to go for the main
          attractions first, especially Harry Potter land. Try the butterbeer.
        </p>
        <p>
          Food is expensive inside, so be ready to spend. There are water
          filters around.
        </p>
      </div>
    );
  }
}
